import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body d-flex flex-column p-0 justify-content-between flex-column overflow-hidden" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"pb-0 px-5 pt-9 pb-3\"><div class=\"d-flex flex-stack flex-wrap\"><div class=\"me-2\"><a href=\"#\" class=\"text-dark text-hover-primary fw-bolder fs-3\">API Keys</a><div class=\"text-muted fs-7 fw-bold\">API Keys Chart</div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_apexchart, {
        class: "mixed-widget-10-chart card-rounded-bottom",
        options: _ctx.chartOptions,
        series: _ctx.series,
        type: "bar",
        height: _ctx.chartHeight
      }, null, 8, ["options", "series", "height"])
    ])
  ], 2))
}